export default {
  name: 'login',
  data: function () {
    return {
      loginId: '',
      password: '',
      keepLogin: true,
      app_type: 'houkokusyo'
    }
  },
  created() {
    this.$store.dispatch('AUTH_CLEAR')
  },
  computed: {
    error () {
      return this.$store.getters.authError || this.$store.getters.apiError
    }
  },
  methods: {
    login: function() {
      var formData = new FormData();
      formData.append('auth_user[login_id]', this.loginId);
      formData.append('auth_user[password]', this.password);
      formData.append('login_type', 'user_only')
      formData.append('app_type', this.app_type);
      this.$store.dispatch('LOGIN', {data: formData, keepLogin: this.keepLogin})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/login.js